export const SHOW_CAROUSEL_VIDEO = 'SHOW_CAROUSEL_VIDEO';

export const UGC_DISPLAY_TYPE_GALLERY = 'GALLERY';
export const UGC_DISPLAY_TYPE_ROW = 'ROW';

export default {
    SHOW_CAROUSEL_VIDEO
};
